import { EventChannel } from '@domain/channel';
import { useGenericQuery } from '@hooks/use-generic-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

const getEventChannelsByIdFetch = async (eventId: string) => {
  const url = `${import.meta.env.VITE_EVENTS_HOST}/v1/nightgraph/events/${eventId}/channels`;

  return request({ url, method: RequestMethod.GET });
};

export const useGetChannels = ({ eventId = '', enabled = true }: { eventId?: string; enabled?: boolean }) => {
  return useGenericQuery<EventChannel[], RequestError>(
    ['event-channels-by-id', eventId],
    () => getEventChannelsByIdFetch(eventId),
    {
      enabled,
    }
  );
};
